export enum RouteParam {

  Id = "id",
  Name = 'name',
  Index = "index",

  //finance
  AccountGroupId = "accountGroupId",
  MappingType = "mappingType",

  // trading partner
  PartnerType = "partnerType",
  PartnerCategory = "partnerCategory",

  // recruit to hire
  JobReqId = "jobReqId",
  CandidateId = "candidateId",
  CandidateUserId = "candidateUserId",
  InterviewId = "interviewId",
  UserId = "userId",

  // appraisal
  AppraisalId = "appraisalId",
  AppraisalViewBy = "viewBy",

  //Accounts Receivable
  Invoice = "invoice",
  PartnerId = "partnerId",
  SalesOrderId = "salesOrderId",
  PackingSlipId = "packingSlipId",
  ReturnId = "returnId",
  Transaction= "transaction"

}
